// ************* OnBoarding *************

export const loginURL = {
	url: "/auth/admin/login",
	method: "POST",
};
export const setBasicInfo = {
	url: "/auth/admin/login",
	method: "PATCH",
};

export const registerUserURL = {
	url: "/auth/admin/register",
	method: "POST",
};

export const verifyOTPURL = {
	url: "/auth/admin/verify-email-otp",
	method: "POST",
};

export const forgotPasswordURL = {
	url: "/auth/admin/forgot-password",
	method: "POST",
};

export const verifyFPOTPURL = {
	url: "/auth/admin/forgot-password/verify-email-otp",
	method: "POST",
};

export const setPasswordURL = {
	url: "/auth/admin/forgot-password/reset-password",
	method: "PATCH",
};

export const resendFPOTPURL = {
	url: "/auth/admin/forgot-password/resend-email-otp",
	method: "POST",
};

export const resendOTPURL = {
	url: "/auth/admin/resend-email-otp",
	method: "POST",
};

export const getAccessTokenURL = {
	url: "/auth/admin/reissue-jwt-token",
	method: "POST",
};

// Profile of the currently logged-in admin (name + email).
export const getAdminInfoURL = {
	url: "/auth/admin/info",
	method: "GET",
};

export const setBusinessInfo = {
	url: "/merchant/auth/set-business-info",
	method: "PATCH",
};

export const setBrandInfo = {
	url: "/merchant/auth/set-brand-details",
	method: "PATCH",
};

export const setBankInfo = {
	url: "/merchant/auth/set-bank-details",
	method: "PATCH",
};

// ************* OTP *************

export const verifySMSOtp = {
	url: "/auth/merchant/verify-sms-otp",
	method: "POST",
};

export const resendSMSOtp = {
	url: "/auth/merchant/resend-sms-otp",
	method: "POST",
};

export const verifyEmailOtp = {
	url: "/auth/merchant/verify-email-otp",
	method: "POST",
};

export const resendEmailOtp = {
	url: "/auth/merchant/resend-email-otp",
	method: "POST",
};
